import Chat from './Chat'

export default {
  Chat
}



// WEBPACK FOOTER //
// ./src/components/BeChat/index.js